import {
  Component,
  ViewChild,
  ElementRef,
  Input,
  ChangeDetectorRef,
  HostListener,
  Output,
  EventEmitter,
  ChangeDetectionStrategy,
} from '@angular/core';

// @TODO HL-33922 consolidate: this is exactly the same as tooltip but might change once design team provides specification
export enum TooltipSizes {
  SMALL = 'small',
  MEDIUM = 'medium',
  LARGE = 'large',
}

export enum TooltipPositions {
  ABOVE = 'above',
  BELOW = 'below',
  LEFT = 'left',
  RIGHT = 'right',
}

export enum TooltipVariations {
  PRIMARY = 'primary',
  INVERSE = 'inverse',
}

export enum TooltipOrientations {
  CENTER = 'center',
  LEFT = 'left',
  RIGHT = 'right',
}

/**
 * @deprecated, use cpds-popover instead
 */
@Component({
  selector: 'cp-popover',
  templateUrl: './cp-popover.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CpPopoverComponent {
  clickedInside: boolean = false;
  isLeftOffScreen: boolean = false;
  isRightOffScreen: boolean = false;
  open: boolean = false;
  @Output() openEvent: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Input() size: TooltipSizes | string = TooltipSizes.MEDIUM;
  @Input() position: TooltipPositions | string = TooltipPositions.BELOW;
  @Input() variation = TooltipVariations.PRIMARY;
  @Input() orientation = TooltipOrientations.CENTER;
  @Input() allowAutoOrientation = false;

  @ViewChild('container') containerRef: ElementRef<HTMLElement>;
  @ViewChild('contentWrapper') contentWrapperRef: ElementRef<HTMLElement>;

  constructor(private elRef: ElementRef<HTMLElement>, private cdr: ChangeDetectorRef) {}

  checkOffScreen() {
    const containerElement = this.containerRef.nativeElement;
    const contentWrapper = this.contentWrapperRef.nativeElement;
    const { left: containerElementLeft } = containerElement.getBoundingClientRect();
    const { width: contentWrapperWidth } = contentWrapper.getBoundingClientRect();
    const { right: bodyRight } = document.body.getBoundingClientRect();

    this.isLeftOffScreen = containerElementLeft < contentWrapperWidth / 2;
    this.isRightOffScreen = containerElementLeft + contentWrapperWidth / 2 > bodyRight;

    // allowAutoOrientation flag was added to not break anyone elses
    // use of the tooltip. Passing True to allowAutoOrientation
    // will prevent the tooltip from going off screen (useful for things like mobile etc)
    if (this.allowAutoOrientation) {
      // if tool tip ever goes off the screen it gets corrected
      if (this.isLeftOffScreen) {
        this.orientation = TooltipOrientations.RIGHT;
      } else if (this.isRightOffScreen) {
        this.orientation = TooltipOrientations.LEFT;
      } else {
        this.orientation = TooltipOrientations.CENTER;
      }
    }
    this.cdr.markForCheck();
  }

  clickInside(event) {
    event.stopPropagation();
  }

  toggle(event) {
    event.stopPropagation(); // only select to open popover and nothing else
    this.open = !this.open;
    this.openEvent.emit(this.open);
    requestAnimationFrame(() => this.checkOffScreen());
  }

  blur() {
    //on blur of this div close the popover
    setTimeout(() => {
      // this is for when clicking links inside the popover to make sure it doesnt close
      const focus = document.activeElement;
      if (!this.elRef.nativeElement.contains(focus)) {
        this.open = false;
        this.openEvent.emit(this.open);
        this.cdr.detectChanges();
      } else {
        const focusDiv = this.elRef.nativeElement.firstElementChild as HTMLElement;
        focusDiv.focus();
      }
    }, 0);
  }

  @HostListener('window:resize') onresize() {
    if (this.open) {
      this.checkOffScreen();
    }
  }
}
